import React from 'react';

// material
import {Button, Card, CardContent, Grid, withStyles} from '@material-ui/core';
//styles
import styles from './password-card-styles';

const PasswordCardView = (props)=> {
  const {
    classes,
    isLoading
  } = props;

  return(
    <Card>
      <CardContent>
        <Grid container className={classes.displayTitle} spacing={2}>
            <Grid item>Password</Grid>
            <Grid item>
                <Button
                    color={'primary'}
                    size={'small'}
                    variant={'contained'}
                    onClick={() => props.toggleEdit()}>
                    Change Password
                </Button>
            </Grid>
        </Grid>
        {
          !isLoading &&
          <Grid container className={classes.displayBody} spacing={2}>
            <Grid item>Current Password : </Grid>
            <Grid item>************</Grid>
          </Grid>
        }
      </CardContent>
    </Card>
  )
};

export default withStyles(styles) (PasswordCardView);
